module.exports = __webpack_public_path__ + "img/coach_activity1.01263c0e.jpeg";